import React from 'react'
import { Bar } from '@ant-design/charts'
import { Card } from 'antd'

interface BreakdownItem {
  label: string
  count: number
}

interface Props {
  data: BreakdownItem[]
}

const ByLegalForm = ({ data }: Props) => {
  const sorted = [...data].sort((a, b) => b.count - a.count).slice(0, 15)

  const config = {
    data: sorted.map(d => ({ label: d.label, count: d.count })),
    xField: 'count',
    yField: 'label',
    colorField: 'label',
    legend: false as const,
    label: {
      style: { fill: '#555', fontSize: 11 },
    },
  }

  return (
    <Card title="Répartition par forme juridique" style={{ borderRadius: 8 }}>
      <Bar {...config} height={Math.max(220, sorted.length * 28)} />
    </Card>
  )
}

export default ByLegalForm
